<template>
  <div class="route-management">
    <div class="main-content">
      <div class="filter-section">
        <div class="filter-form">
          <div class="filter-item">
            <a-input
              v-model:value="filters.searchText"
              placeholder="搜索线路名称、客户网点、出发地、到达地、负责人"
              allowClear
              @change="handleSearchChange"
            >
              <a-icon type="search" slot="prefix" />
            </a-input>
          </div>
        </div>
        <div class="filter-actions">
          <a-button type="primary" @click="handleSearch">查询</a-button>
          <a-button @click="handleReset">重置</a-button>
        </div>
      </div>

      <div class="action-bar">
        <a-button type="primary" @click="handleAdd">
          + 新增线路
        </a-button>
      </div>

      <div class="table-section">
        <vxe-table
          ref="vxeTableRef"
          :data="filteredData"
          auto-resize
          :column-config="{ resizable: true }"
          :row-config="{ isHover: true, height: 40 }"
          :show-overflow="'title'"
        >
          <vxe-column type="seq" width="60" title="序号" fixed="left" />
          <vxe-column field="name" title="线路名称" min-width="140" fixed="left" />
          <vxe-column field="client" title="客户网点" min-width="140" />
          <vxe-column field="origin" title="出发地" min-width="120" />
          <vxe-column field="dest" title="到达地" min-width="120" />
          <vxe-column field="mileage" title="里程数（km）" width="120">
            <template #default="{ row }">
              <span>{{ row.mileage ? row.mileage + ' km' : '--' }}</span>
            </template>
          </vxe-column>
          <vxe-column field="person" title="线路负责人" min-width="120" />
          <vxe-column field="note" title="备注" min-width="120" />
          <vxe-column title="操作" width="auto" fixed="right" align="right">
            <template #default="{ row }">
              <button class="link-button" @click="handleEdit(row)">编辑</button>
              <button class="link-button danger" @click="handleDelete(row)">删除</button>
            </template>
          </vxe-column>
        </vxe-table>

        <div class="pagination-wrapper">
          <a-pagination
            v-model:current="currentPage"
            :page-size="pageSize"
            :page-size-options="['10', '20', '50', '100']"
            :total="filteredData.length"
            :showSizeChanger="true"
            :showQuickJumper="true"
            :showTotal="showTotalText"
            @change="handlePageChange"
            @showSizeChange="handleSizeChange"
          />
        </div>
      </div>
    </div>

    <!-- 新增/编辑线路抽屉 -->
    <Drawer :visible="drawerVisible" @update:visible="drawerVisible = $event">
      <template #title>
        <span class="drawer-title-text">{{ isEdit ? '编辑线路' : '新增线路' }}</span>
      </template>
      <div class="drawer-content">
        <a-form :form="routeForm" layout="vertical">
          <div class="form-grid">
            <div class="form-grid-item">
              <a-form-item label="线路名称" required>
                <a-input
                  v-decorator="['name', { rules: [{ required: true, message: '请输入线路名称' }] }]"
                  placeholder="请输入线路名称"
                />
              </a-form-item>
            </div>
            <div class="form-grid-item">
              <a-form-item label="客户网点" required>
                <a-input
                  v-decorator="['client', { rules: [{ required: true, message: '请输入客户网点' }] }]"
                  placeholder="请输入客户网点"
                />
              </a-form-item>
            </div>
            <div class="form-grid-item">
              <a-form-item label="出发地" required>
                <a-input
                  v-decorator="['origin', { rules: [{ required: true, message: '请输入出发地' }] }]"
                  placeholder="请输入出发地"
                />
              </a-form-item>
            </div>
            <div class="form-grid-item">
              <a-form-item label="到达地" required>
                <a-input
                  v-decorator="['dest', { rules: [{ required: true, message: '请输入到达地' }] }]"
                  placeholder="请输入到达地"
                />
              </a-form-item>
            </div>
            <div class="form-grid-item">
              <a-form-item label="里程数（km）" required>
                <a-input
                  v-decorator="['mileage', { rules: [{ required: true, message: '请输入里程数' }] }]"
                  placeholder="请输入里程数"
                >
                  <span slot="suffix">km</span>
                </a-input>
              </a-form-item>
            </div>
            <div class="form-grid-item">
              <a-form-item label="线路负责人" required>
                <a-input
                  v-decorator="['person', { rules: [{ required: true, message: '请输入线路负责人' }] }]"
                  placeholder="请输入线路负责人"
                />
              </a-form-item>
            </div>
            <div class="form-grid-item full-width">
              <a-form-item label="备注">
                <a-textarea
                  v-decorator="['note']"
                  placeholder="请输入备注"
                  style="height: 80px; resize: none;"
                />
              </a-form-item>
            </div>
          </div>
        </a-form>
        <div class="form-actions">
          <a-button @click="handleCancel">取消</a-button>
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading">{{ submitLoading ? (isEdit ? '保存中...' : '提交中...') : (isEdit ? '保存' : '确定') }}</a-button>
        </div>
      </div>
    </Drawer>
  </div>
</template>

<script>
import Drawer from '@/components/Drawer.vue'

const ROUTE_KEY = 'route_data'

export default {
  name: 'RouteManagement',
  components: {
    Drawer
  },
  data() {
    return {
      filters: {
        searchText: ''
      },
      currentPage: 1,
      pageSize: 10,
      tableData: [
        {
          id: 1,
          name: '萧山-黄山',
          client: '萧山物流园',
          origin: '萧山',
          dest: '黄山',
          mileage: '280',
          person: '张三',
          note: '常规运输线路'
        },
        {
          id: 2,
          name: '黄山-萧山',
          client: '黄山物流园',
          origin: '黄山',
          dest: '萧山',
          mileage: '280',
          person: '李四',
          note: '返程运输'
        },
        {
          id: 3,
          name: '杭州-黄山',
          client: '杭州集散中心',
          origin: '杭州',
          dest: '黄山',
          mileage: '260',
          person: '王五',
          note: '高频线路'
        },
        {
          id: 4,
          name: '上海-黄山',
          client: '上海浦东仓',
          origin: '上海',
          dest: '黄山',
          mileage: '450',
          person: '赵六',
          note: '长途线路，注意充电'
        },
        {
          id: 5,
          name: '宁波-黄山',
          client: '宁波北仑港',
          origin: '宁波',
          dest: '黄山',
          mileage: '380',
          person: '钱七',
          note: ''
        },
        {
          id: 6,
          name: '温州-黄山',
          client: '温州物流园',
          origin: '温州',
          dest: '黄山',
          mileage: '420',
          person: '孙八',
          note: '山路较多，注意安全'
        }
      ],
      drawerVisible: false,
      isEdit: false,
      editIndex: -1,
      routeForm: this.$form.createForm(this),
      submitLoading: false
    }
  },
  computed: {
    filteredData() {
      let data = this.tableData
      if (this.filters.searchText) {
        const kw = this.filters.searchText.toLowerCase()
        data = this.tableData.filter(item => {
          return (item.name && item.name.toLowerCase().includes(kw)) ||
            (item.client && item.client.toLowerCase().includes(kw)) ||
            (item.origin && item.origin.toLowerCase().includes(kw)) ||
            (item.dest && item.dest.toLowerCase().includes(kw)) ||
            (item.person && item.person.toLowerCase().includes(kw))
        })
      }
      // 倒序排列（最新的数据排在最前面）
      return [...data].reverse()
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    showTotalText(total) {
      return `共 ${total} 条`
    },
    handleSearchChange(e) {
      this.filters.searchText = e.target.value
    },
    handleSearch() {
      this.currentPage = 1
    },
    handleReset() {
      this.filters.searchText = ''
      this.currentPage = 1
    },
    handlePageChange(page, pageSize) {
      this.currentPage = page
      this.pageSize = pageSize
    },
    handleSizeChange(current, size) {
      this.currentPage = 1
      this.pageSize = size
    },
    loadData() {
      try {
        const data = localStorage.getItem(ROUTE_KEY)
        if (data) {
          this.tableData = JSON.parse(data)
        }
      } catch (e) {
        this.tableData = []
      }
    },
    saveData() {
      localStorage.setItem(ROUTE_KEY, JSON.stringify(this.tableData))
    },
    handleAdd() {
      this.isEdit = false
      this.editIndex = -1
      this.drawerVisible = true
      this.$nextTick(() => {
        this.routeForm.resetFields()
      })
    },
    handleEdit(row) {
      this.isEdit = true
      // 从数据源查找当前行最新的数据
      const currentItem = this.tableData.find(item => item.id === row.id)
      this.editIndex = this.tableData.findIndex(item => item.id === row.id)
      this.drawerVisible = true
      this.$nextTick(() => {
        if (currentItem) {
          this.routeForm.setFieldsValue({
            name: currentItem.name || '',
            client: currentItem.client || '',
            origin: currentItem.origin || '',
            dest: currentItem.dest || '',
            mileage: currentItem.mileage || '',
            person: currentItem.person || '',
            note: currentItem.note || ''
          })
        }
      })
    },
    handleCancel() {
      this.drawerVisible = false
      this.routeForm.resetFields()
    },
    handleSubmit() {
      this.routeForm.validateFields((err, values) => {
        if (err) return
        this.submitLoading = true
        setTimeout(() => {
          if (this.isEdit && this.editIndex > -1) {
            // 编辑：更新数据源中对应的记录
            this.tableData[this.editIndex] = { ...this.tableData[this.editIndex], ...values }
          } else {
            // 新增：向数据源添加新记录
            this.tableData.push({
              id: Date.now(),
              ...values
            })
          }
          // 触发响应式更新
          this.tableData = [...this.tableData]
          this.saveData()
          this.submitLoading = false
          this.drawerVisible = false
          this.routeForm.resetFields()
          this.$message.success(this.isEdit ? '编辑成功' : '新增成功')
        }, 300)
      })
    },
    handleDelete(row) {
      this.$confirm({
        title: '确认删除',
        content: '确定要删除该线路吗？',
        okText: '确定',
        cancelText: '取消',
        icon: 'exclamation-circle',
        onOk: () => {
          // 从数据源中查找并删除
          const index = this.tableData.findIndex(item => item.id === row.id)
          if (index > -1) {
            this.tableData.splice(index, 1)
            // 触发响应式更新
            this.tableData = [...this.tableData]
            this.saveData()
            this.$message.success('删除成功')
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.route-management {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
}

.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #fff;
  padding: 24px;
  overflow: auto;
}

.filter-section {
  display: flex;
  align-items: center;
  column-gap: 16px;
  border: 1px solid #D7D7DB;
  border-radius: 8px;
  background: #F7F8FA;
  padding: 23px;
  flex-wrap: wrap;
  margin-bottom: 24px;
  flex-shrink: 0;
}

.filter-form {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  flex: 1;
}

.filter-item {
  min-width: 200px;
}

.filter-actions {
  display: flex;
  gap: 8px;
}

.filter-item :deep(.ant-select),
.filter-item :deep(.ant-input),
.filter-item :deep(.ant-cascader) {
  width: 100% !important;
  display: block !important;
}

.action-bar {
  padding: 0;
  margin-bottom: 8px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.table-section {
  flex: 1;
  background: #fff;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
}

.link-button {
  background: none;
  border: none;
  color: #516EFD;
  cursor: pointer;
  padding: 0 4px;
  font-size: 14px;
  outline: none;
}

.link-button:hover {
  color: #4058E8;
}

.link-button:active {
  color: #3A4FBF;
}

.link-button.danger {
  color: #516EFD;
}

.link-button.danger:hover {
  color: #3A5CE4;
}

.link-button.danger:active {
  color: #284FCC;
}

.pagination-wrapper {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}

.drawer-title-text {
  font-size: 16px;
  font-weight: 600;
  color: #1B1C33;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  row-gap: 16px;
  column-gap: 16px;
}

.form-grid-item {
  display: flex;
  flex-direction: column;
}

.form-grid-item .ant-form-item {
  margin-bottom: 0;
}

.form-grid-item .ant-form-item-label {
  padding-bottom: 4px;
}

.form-grid-item .ant-form-item-control-input {
  min-height: auto;
}

.form-grid-item .ant-input,
.form-grid-item .ant-select-selector,
.form-grid-item .ant-input-affix-wrapper {
  padding: 0 8px;
}

.form-grid-item.full-width {
  grid-column: 1 / -1;
}

.form-actions {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 16px;
}
</style>
